import newStyled from '@emotion/styled';
import { Radio } from 'antd';
import UserStore from 'mobx/UserStore';
import { useTranslation } from 'react-i18next';

export function SpLanguageSwitch() {
  const { i18n } = useTranslation();
  const user = UserStore.selectBranch;

  const changeLanguage = (lang) => {
    localStorage?.setItem?.('lang', lang);
    i18n.changeLanguage(lang);
  };

  if (user?.chooseBranch?.value === 'nonthaburi') {
    return null;
  }

  return (
    <RadioButtonGroup defaultValue={i18n.language} buttonStyle="solid" onChange={(e) => changeLanguage(e.target.value)}>
      <Radio.Button value="th">TH</Radio.Button>
      <Radio.Button value="en">EN</Radio.Button>
    </RadioButtonGroup>
  );
}

const RadioButtonGroup = newStyled(Radio.Group)({
  '.ant-radio-button-wrapper': {
    marginBottom: 0,
    fontSize: 14,
    height: 28,
    lineHeight: '24px',
    padding: '0 11.5px',

    '&.ant-radio-button-wrapper-checked': {
      background: '#ff0000',
      borderColor: '#6f8294',
      ':not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child': {
        borderRightColor: '#ff0000',
      },
      ':hover': {
        background: '#e14e4e',
      },
    },
  },
});
